<template lang="pug" src="./slider-home-testimonials.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  },
  async mounted () {
    setInterval(() => {
      this.active === (this.props.slides.length - 1) ? this.active = 0 : this.active++
    }, 6000)
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/slider/slider-home-testimonials/slider-home-testimonials.vue